import { useState } from 'react';
import { Link } from 'react-router-dom';

const steps = [
  {
    number: 1,
    title: 'Abra o WhatsApp no seu celular',
    description:
      'No Android: toque nos 3 pontinhos no canto superior direito e vá em "Aparelhos Conectados". No iPhone: vá em "Configurações" → "Dispositivos Conectados".',
    icon: 'ri-smartphone-line',
    image:
      'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20WhatsApp%20app%20with%20menu%20open%20showing%20connected%20devices%20option%2C%20clean%20modern%20UI%2C%20light%20background%2C%20professional%20mobile%20app%20screenshot%20style%2C%20warm%20tones&width=1600&height=900&seq=tutorial-saas-step1-2026&orientation=landscape',
  },
  {
    number: 2,
    title: 'Escaneie o QR Code no WZap PRO',
    description:
      'No painel do WZap PRO, clique em "Conectar WhatsApp". Um QR Code vai aparecer na tela. No celular, toque em "Conectar um Aparelho" e aponte a câmera para o QR Code.',
    icon: 'ri-qr-scan-line',
    image:
      'https://readdy.ai/api/search-image?query=Computer%20monitor%20showing%20a%20large%20QR%20code%20on%20a%20clean%20web%20dashboard%2C%20smartphone%20camera%20scanning%20it%2C%20modern%20minimal%20desk%20setup%2C%20warm%20natural%20lighting%2C%20professional%20photography%2C%20soft%20shadows&width=1600&height=900&seq=tutorial-saas-step2-2026&orientation=landscape',
  },
  {
    number: 3,
    title: 'Pronto! Comece a enviar campanhas',
    description:
      'Assim que o QR Code for escaneado, seu WhatsApp estará conectado ao WZap PRO. Você pode agora criar campanhas, importar contatos e enviar mensagens em massa.',
    icon: 'ri-send-plane-fill',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20web%20dashboard%20showing%20a%20successful%20WhatsApp%20connection%20status%20in%20green%2C%20campaign%20creation%20interface%2C%20clean%20UI%20design%2C%20light%20background%2C%20professional%20admin%20panel%20with%20charts%20and%20metrics&width=1600&height=900&seq=tutorial-saas-step3-2026&orientation=landscape',
  },
];

const faqs = [
  {
    q: 'Preciso de um número de WhatsApp novo?',
    a: 'Não! Você pode usar seu número de WhatsApp pessoal ou comercial existente. O WhatsApp permite conectar até 4 aparelhos simultaneamente.',
  },
  {
    q: 'Posso usar o WhatsApp no celular e no WZap PRO ao mesmo tempo?',
    a: 'Sim! O WhatsApp no seu celular continua funcionando normalmente. As mensagens sincronizam automaticamente entre o celular e o WZap PRO.',
  },
  {
    q: 'O QR Code expirou, o que faço?',
    a: 'QR Codes do WhatsApp expiram em cerca de 1 minuto. Se expirar, clique em "Reconectar" no painel do WZap PRO que um novo QR Code será gerado automaticamente.',
  },
  {
    q: 'O WhatsApp pode banir minha conta?',
    a: 'Usar o WZap PRO é seguro. Desde que você envie mensagens para contatos que conhecem seu número e evite spam, não há risco de banimento.',
  },
  {
    q: 'Meu celular precisa ficar ligado?',
    a: 'Sim, o celular precisa estar conectado à internet (Wi-Fi ou 4G/5G) para que o WZap PRO possa enviar mensagens pelo seu WhatsApp.',
  },
  {
    q: 'Quantas mensagens posso enviar por dia?',
    a: 'Isso depende do seu plano. Consulte a página "Meu Uso" no painel para ver seus limites atuais. Recomendamos não exceder 30 mensagens por minuto.',
  },
];

export default function TutorialWhatsAppPage() {
  const [videoLoaded, setVideoLoaded] = useState(false);

  return (
    <div className="min-h-screen bg-background-50">
      {/* Schema.org FAQPage JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "Preciso de um número de WhatsApp novo?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Não! Você pode usar seu número de WhatsApp pessoal ou comercial existente. O WhatsApp permite conectar até 4 aparelhos simultaneamente."
                }
              },
              {
                "@type": "Question",
                "name": "Posso usar o WhatsApp no celular e no WZap PRO ao mesmo tempo?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Sim! O WhatsApp no seu celular continua funcionando normalmente. As mensagens sincronizam automaticamente entre o celular e o WZap PRO."
                }
              },
              {
                "@type": "Question",
                "name": "O QR Code expirou, o que faço?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "QR Codes do WhatsApp expiram em cerca de 1 minuto. Se expirar, clique em Reconectar no painel do WZap PRO que um novo QR Code será gerado automaticamente."
                }
              },
              {
                "@type": "Question",
                "name": "O WhatsApp pode banir minha conta?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Usar o WZap PRO é seguro. Desde que você envie mensagens para contatos que conhecem seu número e evite spam, não há risco de banimento."
                }
              },
              {
                "@type": "Question",
                "name": "Meu celular precisa ficar ligado?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Sim, o celular precisa estar conectado à internet (Wi-Fi ou 4G/5G) para que o WZap PRO possa enviar mensagens pelo seu WhatsApp."
                }
              },
              {
                "@type": "Question",
                "name": "Quantas mensagens posso enviar por dia?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Isso depende do seu plano. Consulte a página Meu Uso no painel para ver seus limites atuais. Recomendamos não exceder 30 mensagens por minuto."
                }
              }
            ]
          })
        }}
      />
      {/* Hero */}
      <section className="relative w-full overflow-hidden" style={{ minHeight: '420px' }}>
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20warm%20green%20and%20cream%20tones%2C%20soft%20gradients%2C%20minimalist%20tech%20aesthetic%2C%20modern%20clean%20design%2C%20subtle%20texture%2C%20no%20text%2C%20abstract%20art%20style&width=1800&height=900&seq=tutorial-hero-saas-2026&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-background-50" />
        <div
          className="relative z-10 flex flex-col items-center justify-center text-center px-4 py-20"
          style={{ minHeight: '420px' }}
        >
          <div className="w-16 h-16 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center mb-6">
            <i className="ri-whatsapp-fill text-3xl text-white" />
          </div>
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 max-w-2xl">
            Como conectar seu WhatsApp
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-xl leading-relaxed">
            Em apenas 3 passos simples, seu WhatsApp estará conectado ao WZap PRO e você poderá enviar campanhas.
          </p>
          <div className="flex items-center gap-3 mt-8">
            <Link
              to="/settings/whatsapp"
              className="px-6 py-3 bg-white text-foreground-950 rounded-full text-sm font-semibold hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap"
            >
              Acessar painel e conectar WhatsApp
            </Link>
            <a
              href="#steps"
              className="px-6 py-3 bg-white/10 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-semibold hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap"
            >
              Ver tutorial <i className="ri-arrow-down-line ml-1" />
            </a>
          </div>
        </div>
      </section>

      {/* YouTube Video */}
      <section className="max-w-4xl mx-auto px-4 md:px-6 pt-16">
        <div className="bg-white rounded-2xl border border-background-200 overflow-hidden">
          <div className="p-5 md:p-6">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-lg bg-red-50 flex items-center justify-center">
                <i className="ri-youtube-fill text-red-600" />
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-950">
                Assista ao tutorial em vídeo
              </h3>
            </div>
            <p className="text-sm text-foreground-500 mb-4">
              Prefere aprender vendo? Assista ao passo a passo completo em vídeo:
            </p>
          </div>
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              src="https://www.youtube.com/embed/dQw4w9WgXcQ"
              title="Tutorial WZap PRO - Como conectar seu WhatsApp"
              className="absolute inset-0 w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              onLoad={() => setVideoLoaded(true)}
            />
          </div>
          {!videoLoaded && (
            <div className="absolute inset-0 flex items-center justify-center bg-background-100">
              <div className="flex flex-col items-center gap-3">
                <div className="w-10 h-10 border-2 border-primary-500 border-t-transparent rounded-full animate-spin" />
                <p className="text-sm text-foreground-500">Carregando vídeo...</p>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Steps */}
      <section id="steps" className="max-w-4xl mx-auto px-4 md:px-6 py-16 space-y-16">
        <div className="text-center mb-12">
          <span className="px-3 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-semibold uppercase tracking-wider">
            3 passos
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-4">
            Guia rápido de conexão
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            Não precisa instalar nada. É só escanear o QR Code e pronto.
          </p>
        </div>

        {steps.map((step, idx) => (
          <div key={step.number} className="relative">
            {/* Connecting line */}
            {idx < steps.length - 1 && (
              <div
                className="absolute left-6 top-16 bottom-0 w-px bg-background-200 hidden md:block"
                style={{ height: 'calc(100% + 48px)' }}
              />
            )}

            <div className="flex flex-col md:flex-row gap-6 md:gap-10">
              {/* Step number */}
              <div className="flex-shrink-0 flex md:flex-col items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-primary-500 text-white flex items-center justify-center text-lg font-heading font-bold z-10">
                  {step.number}
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 bg-white rounded-2xl border border-background-200 overflow-hidden">
                {/* Image */}
                <div className="w-full h-56 md:h-64 overflow-hidden">
                  <img src={step.image} alt={step.title} className="w-full h-full object-cover" />
                </div>

                <div className="p-5 md:p-6">
                  <div className="flex items-center gap-2.5 mb-3">
                    <div className="w-8 h-8 rounded-lg bg-primary-50 flex items-center justify-center">
                      <i className={`${step.icon} text-primary-600`} />
                    </div>
                    <h3 className="text-lg font-heading font-semibold text-foreground-950">
                      {step.title}
                    </h3>
                  </div>

                  <p className="text-sm text-foreground-600 leading-relaxed">{step.description}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* CTA Banner */}
      <section className="max-w-4xl mx-auto px-4 md:px-6 pb-16">
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20gradient%20with%20warm%20green%20and%20cream%20tones%2C%20soft%20organic%20shapes%2C%20minimalist%20design%2C%20professional%20background%20for%20call%20to%20action%2C%20no%20text&width=1600&height=600&seq=tutorial-saas-cta-2026&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-600/90 to-primary-700/80" />
          <div className="relative z-10 py-12 px-6 text-center">
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
              Pronto para começar?
            </h3>
            <p className="text-sm text-white/80 max-w-md mx-auto mb-6">
              Acesse o painel do WZap PRO, conecte seu WhatsApp em segundos e envie sua primeira campanha.
            </p>
            <Link
              to="/settings/whatsapp"
              className="inline-flex px-6 py-3 bg-white text-primary-700 rounded-full text-sm font-semibold hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap items-center gap-2"
            >
              <i className="ri-qr-code-line" /> Conectar WhatsApp
            </Link>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-white border-t border-background-200 py-16">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <span className="px-3 py-1 bg-secondary-100 text-secondary-700 rounded-full text-xs font-semibold uppercase tracking-wider">
              Dúvidas
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-4">
              Perguntas frequentes
            </h2>
          </div>

          <div className="space-y-3">
            {faqs.map((faq) => (
              <details
                key={faq.q}
                className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden"
              >
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                  <span className="text-sm font-semibold text-foreground-900 pr-4">
                    {faq.q}
                  </span>
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform flex-shrink-0" />
                </summary>
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-background-50 border-t border-background-200 py-8">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} WZap PRO ·{' '}
            <Link to="/" className="hover:text-foreground-600 transition-colors">
              Voltar ao início
            </Link>
          </p>
        </div>
      </footer>
    </div>
  );
}